import Slider from "./slider";

class DragTitle {
    constructor(el) {
        this.el = el;
        this.$scrollTitle = $(el);

        this.init();
    }

    init() {
        let title = this.$scrollTitle.html();
        // append it two more times so we have the title 3 times to get a
        // smooth infinite carousel going without compromising SEO with more than 1 h1 element
        this.$scrollTitle.append(title);
        this.$scrollTitle.append(title);

        new Slider(this.el, {
            prevNextButtons: false,
            pageDots: false,
            accessibility: false,
            wrapAround: true,
            freeScroll: true,
            cellAlign: 'left'
        });
    }
}

export default DragTitle;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/dragTitle.js